export default __webpack_public_path__ + "static/media/pradeep.27dea6e5.jpeg";